import React, { useRef } from 'react'
import { Box, Button } from '@mui/material'

const CustomFileInputButton = ( {
    accept = "",
    onChange,
    children = "Upload File",
    ...props
} ) => {
    // Create a reference to the hidden input element
    const fileInputRef = useRef( null )

    const handleButtonClick = () => {
        // Trigger the click event on the hidden input
        fileInputRef.current.click()
    }

    const handleFileChange = ( event ) => {
        if ( onChange ) {
            onChange( event )
        }
    }

    return (
        <Box>
            {/* Hidden Input Field */}
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={accept}
                style={{ display: 'none' }} // Hide the actual input
            />

            {/* Visible MUI Button */}
            <Button
                variant="contained"
                onClick={handleButtonClick}
                {...props}
            >
                {children}
            </Button>
        </Box>
    )
}

export default CustomFileInputButton